<template>
  <div class="onestop-company" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="整包公司" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div v-if="adList.length>0">
      <img style="width:7.5rem;height: 1.4rem;" v-for="ad in adList" v-if="ad.relationId" @click="toArticleDetail(ad.relationId,'','')" :src="imgUrl+ad.attachment"/>
      <img style="width:7.5rem;height: 1.4rem;" v-for="ad in adList" v-if="!ad.relationId" :src="imgUrl+ad.attachment"/>
    </div>
    <div class="company-item" v-for="company in companyList">
      <div class="top">
        <img @click=openOnestopCompanyDetail(company.id) :src="imgUrl+company.logo"/>
        <div class="base-info">
          <div class="top" @click=openOnestopCompanyDetail(company.id)>
            {{company.name}}
            <img class="platform" src="../../assets/icon-platform-company.png">
            </div>
          <div class="tag-list" @click=openOnestopCompanyDetail(company.id)>
            <div class="tag-item">{{company.constructionGuarantee}}年施工质保</div>
            <div class="line"></div>
            <div class="tag-item">{{company.hydropowerGuarantee}}年水电质保</div>
            <div class="line"></div>
            <div class="tag-item">{{company.waterproofGuarantee}}年卫生间质保</div>
          </div>
        </div>
      </div>
      <div class="management" v-if="company.management" @click=openOnestopCompanyDetail(company.id)><span class="label">主营：</span><span class="info">{{company.management}}</span></div>
    </div>

  </div>
</template>

<script>
  import {imgUrl,shareIcon} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import CompanyService from '../../service/company/CompanyService'
  import shareService from '../../service/share/ShareService'
  import session from '../../utils/Session'

  export default {
    name: 'OnestopCompanyList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        companyList:[],
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        isWechatBrowser:this.$verfyBrowserType(),
        adList:[]
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getCompanyInfo();
      this.initWechatShare();
    },
    methods: {
      async getCompanyInfo(){
        let {code,msg,data} = await CompanyService.getCompanyList();
        if(code == 0){
          let companyList = data.companyList;
          console.info('companyList',companyList)
          for (let company of companyList) {
              // if(company.id != 2){
              // }
            this.companyList.push(company);
          }
          this.adList = data.adList;
        }else {
          Toast('获取整包公司信息失败');
        }
      },
      openOnestopCompanyDetail(companyId){
        const url = `/onestop/company?companyId=${companyId}`
        const background = '#C4A183'
        const font = '#ffffff'
          if(!!this.global.isMiniProgrm ){
              session.isLogin().then(flag => {
                console.log('231123')
                  if (flag) {
                      wx.miniProgram.navigateTo({url: `/pages/h5/webview/index?path=${encodeURIComponent(url)}&nbBackgroundColor=${encodeURIComponent(background)}&nbFrontColor=${encodeURIComponent(font)}`});
                  } else {
                      let backUrl = this.$route.fullPath;
                      wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
                  }
              });
          }else {
              this.$router.push({name:'OnestopCompany',query:{companyId}});
          }
      },
      async openOnestopReservation(companyId,deposit){
          if(!!this.global.isMiniProgrm ){
              session.isLogin().then(flag => {
                  if (flag) {
                      wx.miniProgram.navigateTo({url: `/pages/onestop/reservation/reservation?companyId=${companyId}&deposit=${deposit}`});
                  } else {
                      let backUrl = this.$route.fullPath;
                      wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
                  }
              });
          }else {
              this.$router.push({name:'OnestopReservation',query:{companyId,deposit}});
          }
      },
      //跳转文章详情
      toArticleDetail(id,title,summary){
          this.$router.push({name: 'ArticleDetail', query: {articleId:id,title,summary}})
      },
      async initWechatShare(){
        let title = "吉客家装";// 分享标题
        let desc = "吉客家装——以“包工包料、包主材包辅料”的整装全包模式，搭配监理与业主一对一监理服务，颠覆传统家装模式，解决装修痛点"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
    }
  }
</script>
<style lang="scss">
  .onestop-company{
    background: white;
    color: #1B1E29;
    font-size: 0.28rem;
    .clear-header{
      margin-top: -1rem;
    }
    .company-item{
      margin: 0 auto 0.3rem;
      padding: 0.5rem 0.4rem 0.48rem 0.2rem;
      background: #f7f6f2;
      font-size: 0.3rem;
      color: #333;
      .top{
        display: flex;
      }
      img{
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 1.3rem;
      }
    }
    .base-info{
      width: 5.4rem;
      .top{
        margin-top: 0.14rem;
        margin-left: 0.3rem;
        font-size: 0.34rem;
        color: #333;
        font-weight: bold;
      }
      .platform{
        margin-top: -5px;
        margin-left: 8px;
        width: 80px;
        height: 33px;
        border-radius: 0;
      }
      .tag-list{
        width: 5rem;
        height: 0.6rem;
        line-height: 0.6rem;
        margin-top: 0.21rem;
        margin-left: 0.24rem;
        padding: 0rem 0.1rem;
        display: flex;
        justify-content: space-between;
        background-color: #efebe5;
        border-radius: 0.1rem;
        color: #9d704a;
        font-size: 0.26rem;
        .tag-item{
          white-space: nowrap;
        }
        .line{
          width: 1px;
          height: 0.24rem;
          margin-top: 0.2rem;
          background-color: #9d704a;
        }
      }
      .label{
        font-size: 0.28rem;
        color: #7f7d7c;
      }
    }
    .management{
      padding-left: 0.34rem;
      margin-top: 0.3rem;
      font-size: 0.3rem;
      .label{
        color: #999999;
      }
    }
    .no-msg{
      background: white;
      color: #878e99;
      font-size: 0.28rem;
      text-align: center;
      padding-top: 1rem;
      img{
        width: 1.5rem;margin-bottom: 0.5rem
      }
    }
  }
</style>

